/** @file Mantine 10-shade color tuples for the DripTours brand palette. */

export const coral = [
  '#FFF0F3', // 0 — lightest blush
  '#FFD6DE', // 1
  '#FFB3C1', // 2
  '#FF8FA3', // 3
  '#F7708A', // 4
  '#F36378', // 5
  '#f05776', // 6 — anchor (primary brand)
  '#D94468', // 7
  '#B83358', // 8
  '#8B1A35' // 9 — darkest
];

export const teal = [
  '#E6F7F5', // 0 — lightest mint
  '#C0EDE8', // 1
  '#94DED5', // 2
  '#66CFC3', // 3
  '#42BFB0', // 4
  '#33AE9F', // 5
  '#2A9D8F', // 6 — anchor (accent)
  '#1F8478', // 7
  '#166B62', // 8
  '#0D4F48' // 9 — darkest
];

export const sand = [
  '#FBF7ED', // 0 — lightest cream
  '#F6F0DE', // 1
  '#F0E8CE', // 2
  '#E9D8A6', // 3 — anchor (highlight)
  '#D4C48E', // 4
  '#BFAF76', // 5
  '#A99A60', // 6
  '#8D7F4A', // 7
  '#716538', // 8
  '#574D2A' // 9 — darkest
];

// Warm graphite ramp registered as Mantine's `dark` tuple so computed dark
// colors (Paper, Modal, Input, default borders) land on brand surfaces:
// dark[7] = body, dark[6] = raised (Paper/inputs), dark[0] = primary text.
// Indices 4–5 are solid composites of the alpha borders on surface.base.
export const darkNeutral = [
  '#FAFAF8', // 0 — text.primary
  '#C9C2B8', // 1 — text.secondary
  '#AFA89E', // 2
  '#948D82', // 3 — text.muted
  '#4B4740', // 4 — border.strong (solid equivalent)
  '#302D29', // 5 — border.default (solid equivalent)
  '#23201B', // 6 — surface.raised
  '#1A1714', // 7 — surface.base
  '#131110', // 8 — surface.sunken
  '#0C0A08' // 9 — deepest
];

export const charcoal = [
  '#F1F3F5', // 0 — lightest grey
  '#D8DCE2', // 1
  '#B5BCCA', // 2
  '#8E98AB', // 3
  '#6B7A91', // 4
  '#4F5E74', // 5
  '#3B4A5E', // 6
  '#2D3A4E', // 7
  '#1E293B', // 8 — anchor (ink)
  '#111827' // 9 — darkest
];
